import { Button, Col, Icon, Row, Table, Modal } from 'antd';
import { useEffect, useState } from 'react'
import {getCdiDataPromise} from './promises'
import { useTranslation } from 'react-i18next'
import moment from 'moment';
import { camelizerHelper } from '../../../../../../helpers';
import { ModalPdfViewer } from '../../../../../InterestConflicts/components';
import { ModalIndexCardPage } from '../../../../../InterestConflicts_v2/components/FormManager/components';

const InfoCdi = ({item, forceExpand}) => {

    const [seeMore, setSeeMore] = useState(forceExpand);
    const [formIdView, setFormIdView] = useState(null);
    const [cdiDataSource, setCdiDataSource] = useState(null);
    const [formId, setFormId] = useState(false);
    const { t } = useTranslation()

    useEffect(() => {
        getCdiDataPromise(item.id).then((data) => {
            setCdiDataSource(data)
        })
    }, []);

    const declarationsColumns = [
        {
            title: t("messages.aml.type"),
            dataIndex: 'type',
            render: text => t("messages.aml.type."+text)
        },
        {
            title: t("messages.aml.folio"),
            dataIndex: 'folio'
        },
        {
            title: t("messages.aml.request"),
            dataIndex: "sendDate",
            render: text => moment(text).format('DD/MM/YYYY')
        },
        {
            title: t("messages.aml.status"),
            dataIndex: "status",
            render: text => t("messages.aml.cdi.decl.status."+text)
        },
        {
            title: t("messages.aml.statusDate"),
            dataIndex: 'sendDate',
            render: (text, record) => {
                if(record.status === 'SENT') return moment(record.receiveDate).format('DD/MM/YYYY')
                else return moment(text).format('DD/MM/YYYY')
            }
        },
        {
            title: t("messages.aml.linksRisk"),
            align: 'center',
            dataIndex: 'hasPositives',
            render: ((text, record) => {
                return <>
                    { text ? t("messages.aml.yes") : t("messages.aml.no")} / {record.risk !== null ? t('messages.aml.risk.' + record.risk) : record.status === 'SENT' ? t("messages.aml.notAssigned") : '-'}
                </>
            })
        },
        {
            title: t("messages.aml.reminder"),
            render: (record) => {
                return record.nroReminders ? record.nroReminders+" "+moment(record.lastReminder).format('DD/MM/YYYY') : t("messages.aml.withoutReminder")
            }
        },
        {
            title: t("messages.aml.view"),
            align: 'center',
            dataIndex: "status",
            render: (status, record) => {
                if(status === 'SENT') {
                    return <Button size='small' icon='file-pdf' onClick={() => onClickPdfView(record.id)}/>
                }
            }
        },
        {
            title: t("messages.aml.detail"),
            align: 'center',
            render: (item) => 
                <Button size="small" icon='file' onClick={() => setFormId(item)}/>
        }
    ]

    const handleCloseModalFicha = () => {
        setFormId(null)
    }

    const onClickPdfView = (id) => {
        setFormIdView(id);
    }

    const onCancelPdfViewer = () => {
        setFormIdView(null);
    }
    
    const vinculosColumns = [
        {
            title: t("messages.aml.personType"),
            dataIndex: 'type',
            render: (text) => text === 'Person' ? t("messages.aml.person") : t("messages.aml.company")
        },
        {
            title: t("messages.aml.name"),
            dataIndex: 'nombre',
            render: text => camelizerHelper(text)
        },
        {
            title: t("messages.aml.documentNumber"),
            dataIndex: 'rut'
        },
        {
            title: t("messages.aml.category"),
            dataIndex: 'category',
            render: text => camelizerHelper(text)
        },
    ]
  return (
    <div className='info-cdi-component'>
        <Row>
            <Col span={22}>
                <h3>{t("messages.aml.declarationsManagement")}</h3>
            </Col>
            <Col span={2} style={{textAlign:'right'}}>
                <Button type="link" onClick={() => setSeeMore(!seeMore)}>
                    {seeMore ?
                    <>{t("messages.aml.seeLess")} <Icon type="minus"/></>
                    :
                    <>{t("messages.aml.seeMore")} <Icon type="plus"/></>
                    }
                </Button>
            </Col>
        </Row>
        <hr/>
        {seeMore &&
            <div className={forceExpand ? "" : "div-more-info"} style={{padding: 20}}>
                <Row gutter={[0, 20]}>
                    <Col span={24}>
                        <div style={{fontSize: 16}}>{t("messages.aml.declarationRequest")}</div>
                        <hr/>
                    </Col>
                    <Row className="field-section-row">
                        <Col span={3}>
                            <div className="formCard-onb-modal">
                                {t("messages.aml.requests")} <br/>
                                {cdiDataSource?.forms?.length}
                            </div>
                        </Col>
                        <Col span={3}>
                            <div className="formCard-onb-modal">
                                {t("messages.aml.pending")} <br/>
                                {cdiDataSource?.forms?.filter(form => form.status !== 'SENT').length}
                            </div>
                        </Col>
                        <Col span={3}>
                            <div className="formCard-onb-modal">
                                {t("messages.aml.completed")} <br/>
                                {cdiDataSource?.forms?.filter(form => form.status === 'SENT').length}
                            </div>
                        </Col>
                    </Row>
                    <Col span={24} >
                        <Table dataSource={cdiDataSource?.forms} 
                            columns={declarationsColumns}
                            loading={cdiDataSource === null}
                            pagination={!forceExpand && cdiDataSource?.forms?.length > 10}
                        />
                    </Col>
                    <Col span={24}>
                        <div style={{fontSize: 16}}>{t("messages.aml.links")}</div>
                        <hr/>
                    </Col>
                    <Col span={24} >
                        <Table dataSource={cdiDataSource?.related} 
                            columns={vinculosColumns}
                            loading={cdiDataSource === null}
                            pagination={!forceExpand && cdiDataSource?.related?.length > 10}
                        />
                    </Col>
                </Row>
            </div>
        }

        {formId &&
            <Modal
                wrapClassName="modal-fichaCliente-register"
                style={{top:'10px'}}
                title={t("messages.aml.register")}
                visible={true}
                onCancel={handleCloseModalFicha}
                cancelText={t("messages.aml.btnClose")}
                footer={null}
                width={1200}
            >
                <ModalIndexCardPage item={formId} />
            </Modal>
        }

        {formIdView &&
            <Modal
                className="modal-pdf-viewer"
                title={t("messages.aml.form")}
                centered={true}
                width={1000}
                header={null}
                footer={[<Button key="back" onClick={onCancelPdfViewer}>{t("messages.aml.btnClose")}</Button>]}
                onCancel={onCancelPdfViewer}
                visible="true"
            >
                <ModalPdfViewer
                    pdfId={formIdView}
                />
            </Modal>
        }
    </div>
  )
}

export default InfoCdi
